import { useState, useEffect, useCallback } from 'react';
import { Form } from 'antd';

export const useRemoteDataTable = (useData, rowKey) => {
  const {
    data,
    totalCount,
    loading,
    updating,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    error: errorFromUseData,
    setUpdatedRecord,
  } = useData();

  const [idOfRowBeingEdited, setIdOfRowBeingEdited] = useState(null);
  const [error, setError] = useState<any>(null);
  const [form] = Form.useForm();

  const onEdit = useCallback(
    (record) => {
      form.setFieldsValue(record);
      setIdOfRowBeingEdited(record[rowKey]);
    },
    [form, setIdOfRowBeingEdited, rowKey]
  );

  const onCancelEdit = useCallback(() => {
    setIdOfRowBeingEdited(null);
    form.resetFields();
  }, [form, setIdOfRowBeingEdited]);

  const isRowBeingEdited = useCallback(
    (record) => {
      return idOfRowBeingEdited === record[rowKey];
    },
    [idOfRowBeingEdited, rowKey]
  );

  const onSave = useCallback(
    async (record) => {
      try {
        const updateValues = await form.validateFields();

        const updatedRecord = {
          ...record,
          ...updateValues,
          change_reason: 'Updated via UI',
        };
        setUpdatedRecord({
          id: updatedRecord[rowKey],
          data: updatedRecord,
        });
        onCancelEdit();
      } catch (err) {
        setError(err);
      }
    },
    [form, setUpdatedRecord, onCancelEdit, rowKey]
  );

  const onChangePage = useCallback(
    (page, size) => {
      setCurrentPage(page);
      setPageSize(size);
    },
    [setCurrentPage, setPageSize]
  );

  useEffect(() => {
    setError(errorFromUseData);
  }, [errorFromUseData]);

  return {
    data,
    totalCount,
    loading,
    updating,
    currentPage,
    setCurrentPage,
    pageSize,
    error,
    onEdit,
    onCancelEdit,
    isRowBeingEdited,
    onSave,
    form,
    onChangePage,
  };
};
